import Swiper from "../../../../../vendor/swiper/swiper-bundle.esm.browser";

export default class ProductCategorySwiper {
    constructor($el) {
        this.$el = $el;
        this.swiper = this.swiper.bind(this);
        this.swiper();
    }

    swiper() {
        var swiper = new Swiper(this.$el, {
            slidesPerView: 1,
            spaceBetween: 30,
            navigation: {
                nextEl: this.$el.querySelector('[data-pcl-swiper-next]'),
                prevEl: this.$el.querySelector('[data-pcl-swiper-prev]'),
            },
            breakpoints: {
                640: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                },
                768: {
                    slidesPerView: 4,
                    spaceBetween: 30,
                },
                1400: {
                    slidesPerView: 8,
                    spaceBetween: 30,
                },
            },
        });
    }
}